import type { OrderMessageWithUser } from 'src/api/db/apiOrderMessage'
import { SaraAvatar } from './SaraAvatar'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { formatMessageTimestamp } from '../../../utils/chatMessageDisplay'

export const RequestTeamPingMessage = ({
  message,
}: {
  message: OrderMessageWithUser
}) => {
  const { t } = useLocalization()

  return (
    <Row className="group gap-3 px-3 py-1.5 transition-colors hover:bg-muted/30">
      <SaraAvatar />

      <Column className="min-w-0 flex-1 gap-0.5">
        <Row className="items-baseline gap-2">
          <span className="text-sm font-semibold text-foreground">Sara</span>
          <span className="text-xs text-muted-foreground">
            {formatMessageTimestamp(message.created_at)}
          </span>
        </Row>

        <p className="text-sm leading-relaxed text-foreground">
          {t(
            "I've notified the Klayder team — they'll get back to you here shortly.",
            'Jag har meddelat Klayder-teamet — de återkommer till dig här inom kort.'
          )}
        </p>
      </Column>
    </Row>
  )
}
